import PolicyPage, { Section } from './PolicyPage'
import { PRODUCT_NAME } from '../content/provenance'

/**
 * The accessibility statement. Every claim below is enforced by a gate in
 * `.github/workflows/ci.yml`, so it stays true as long as the pipeline is
 * green. See `.challengeai/challenge-ui.md`.
 */
export default function AccessibilityPage() {
  return (
    <PolicyPage
      title="Accessibility"
      intro={`${PRODUCT_NAME} is built to WCAG 2.1 Level AA, the technical standard Section 508 of the Rehabilitation Act incorporates.`}
    >
      <Section id="standard" heading="The standard">
        <p>
          Section 508 requires federal electronic and information technology to be
          accessible to people with disabilities. WCAG 2.1 Level AA is the
          standard it points at.
        </p>
      </Section>

      <Section id="testing" heading="How it is tested">
        <p>
          Every route is scanned with axe as part of the ordinary test run, and
          again as a rendered page at two viewport sizes. Both run on every
          change, and the page scan blocks a merge rather than reporting.
        </p>
        <p>
          Every route is also checked at a 320 pixel width, so the page works
          without scrolling in two directions.
        </p>
        <p>
          Automated testing covers a portion of what matters, so a manual
          keyboard and screen reader pass stays part of release.
        </p>
      </Section>

      <Section id="feedback" heading="Reporting a barrier">
        <p>
          Anyone who cannot use part of this service can reach the operator
          through the credit in the footer. Reports are answered, and a barrier
          that blocks a task is treated as a defect rather than a request.
        </p>
      </Section>
    </PolicyPage>
  )
}
